import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserRegistrationRequest } from './models/user-registration-request';
import { AuthFlowService } from '../../../../../../core/services/auth-wrapper/auth-flow.service';

@Injectable({
    providedIn: 'root',
})
export class UserRegistrationService {
    constructor(
        private readonly http: HttpClient,
        private readonly authFlowService: AuthFlowService,
    ) {}

    registerUser(userRegistration: UserRegistrationRequest): Observable<void> {
        return this.http.post<void>(
            encodeURI('api/user-registrations'),
            userRegistration,
        );
    }

    registrationComplete(): void {
        this.authFlowService.registrationComplete();
    }
}
